import {Modal, Typography} from 'antd';
import React from 'react';

import {drawerZIndex} from '../../../constants/Common';

const {Text} = Typography;

export const ESGFrameworkDetail: React.FC<{
  companyName: string;
  headerTitle: string;
  contentDetail: string;
  open: boolean;
  onClose: () => void;
}> = ({companyName, headerTitle, contentDetail, open, onClose}) => {
  return (
    <Modal
      title={headerTitle}
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={'50%'}
      zIndex={drawerZIndex}
      className="esgFrameworkBenchmarking"
    >
      <div
        style={{
          marginTop: 20,
          padding: '20px 20px 45px 20px',
          backgroundColor: '#f3f4f8',
          borderTop: 'solid 1px #dee0e4',
          borderBottom: 'solid 1px #dee0e4'
        }}
      >
        <Text strong>{companyName}</Text>
        <br />
        <div style={{marginTop: '10px'}}>
          <Text style={{fontSize: 14}}>{contentDetail}</Text>
        </div>
      </div>
    </Modal>
  );
};

export const PeerAveragePopup: React.FC<{
  contentDetail: string;
  open: boolean;
  onClose: () => void;
}> = ({contentDetail, open, onClose}) => {
  return (
    <Modal
      title={'Peer Average'}
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={'50%'}
      zIndex={drawerZIndex}
      className="esgFrameworkBenchmarking"
    >
      <div
        style={{
          marginTop: 20,
          padding: '20px 20px 45px 20px',
          backgroundColor: '#f3f4f8',
          borderTop: 'solid 1px #dee0e4',
          borderBottom: 'solid 1px #dee0e4'
        }}
      >
        <br />
        <div style={{marginTop: '10px'}}>
          <Text style={{fontSize: 14}}>{contentDetail}</Text>
        </div>
      </div>
    </Modal>
  );
};
